// extracted by mini-css-extract-plugin
export default {"about":"style_about__uT+Oj","header":"style_header__INDEW","content":"style_content__dc0QU"};